import Transactions from "./pages/Transactions";
import ScheduledPayments from "./pages/ScheduledPayments";
import DetailedSalesByDepartment from "./pages/DetailedSalesByDepartment";
import SalesByAccountingReference from "./pages/SalesByAccountingReference";
import InventoryListingByDepartment from "./pages/InventoryListingByDepartment";
import OrderExceptions from "./pages/OrderExceptions";
import TeeSheetUtilization from "./pages/TeeSheetUtilization";
import EmailActivity from "./pages/EmailActivity";
import GolfNorthDailySales from "./pages/GolfNorthDailySales";
import TicketOverview from "./pages/TicketOverview";
import AgedAccountsReceivable from "./pages/AgedAccountsReceivable";
import InventoryAdjustments from "./pages/InventoryAdjustments";
import GiftCardActivity from "./pages/GiftCardActivity";
import TicketsRedeemed from "./pages/TicketsRedeemed";
import Tickets from "./pages/Tickets";
import TicketsExpired from "./pages/TicketsExpired";
import RoundsByCustomerType from "./pages/RoundsByCustomerType";
import MembershipSales from "./pages/MembershipSales";
import NoShow from "./pages/NoShow";
import PlayerSpend from "./pages/PlayerSpend";
import SalesByDepartment from "./pages/SalesByDepartment";
import AccountsReceivable from "./pages/AccountsReceivable";
import Deposits from "./pages/Deposits";
import ItemSalesHistory from "./pages/ItemSalesHistory";
import Tournaments from "./pages/Tournaments";
import TournamentsNotInvoiced from "./pages/TournamentsNotInvoiced";
import Invoices from "./pages/Invoices";
import PrizeAccounts from "./pages/PrizeAccounts";
import DailySales from "./pages/DailySales";
import TeeSheetOverview from "./pages/TeeSheetOverview";
import HospitalityEventsNotInvoiced from "./pages/HospitalityEventsNotInvoiced";
import Orders from "./pages/Orders";
import ServerSummaries from "./pages/ServerSummaries";
import FormResponses from "./pages/FormResponses";
import DetailedSalesAndInventoryByDepartment from "./pages/DetailedSalesAndInventoryByDepartment";
import Leagues from "./pages/Leagues";
import HospitalityEvents from "./pages/HospitalityEvents";
import RoundsByBookingCategory from "./pages/RoundsByBookingCategory";
import Payouts from "./pages/Payouts";
import ProcessingFeeTransactions from "./pages/ProcessingFeeTransactions";
import ProcessingFeeMonthlySummary from "./pages/ProcessingFeeMonthlySummary";
import CashReconciliation from "./pages/CashReconciliation";
import GiftCards from "./pages/GiftCards";
import RainChecks from "./pages/RainChecks";
import TipsByOrder from "./pages/TipsByOrder";
import Waitlist from "./pages/Waitlist";
import UserPaymentMethods from "./pages/UserPaymentMethods";
import PowerCarts from "./pages/PowerCarts";
import CancelledTeeTimeOrders from "./pages/CancelledTeeTimeOrders";
import StaffAccountShifts from "./pages/StaffAccountShifts";
import BagStorage from "./pages/BagStorage";
import CostOfSalesByDepartment from "./pages/CostOfSalesByDepartment";
import CompareSalesByDate from "./pages/CompareSalesByDate";
import BagStorageByDay from "./pages/BagStorageByDay";
import Accounts from "./pages/Accounts";
import SalesByAccountingReferenceStandalone from "./pages/SalesByAccountingReferenceStandalone";
import CashReconciliationWorksheet from "./pages/CashReconciliationWorksheet";
import CreditBooks from "./pages/CreditBooks";
import CreditBookTransactions from "./pages/CreditBookTransactions";
import Discounts from "./pages/Discounts";
import Products from "./pages/Products";
import TaxExempt from "./pages/TaxExempt";
import BookingDeposits from "./pages/BookingDeposits";
import AccountActivity from "./pages/AccountActivity";
import Bookings from "./pages/Bookings";
import BookingsBySource from "./pages/BookingsBySource";
import HourlySales from "./pages/HourlySales";
import RevPAR from "./pages/RevPAR";
import LeagueRounds from "./pages/LeagueRounds";
import TeeTimePromotions from "./pages/TeeTimePromotions";
import RoundsPlayedByCustomer from "./pages/RoundsPlayedByCustomer";
import { withReportAutoRunRoute } from "pages/secure/shared/reports/reportAutoRun/withReportAutoRunRoute";
import { withReportPresentation } from "./ReportPresentationContext";
import PurchaseOrderOutstandingItems from "./pages/PurchaseOrderOutstandingItems";
import LoyaltyProgramRedemptions from "./pages/LoyaltyProgramRedemptions";
import LoyaltyProgramPointsBalance from "./pages/LoyaltyProgramPointsBalance";
import CustomersCreated from "./pages/CustomersCreated";

const reportRoutes: { path: string; component: any }[] = [
  {
    path: "/admin/report/transactions",
    component: Transactions,
  },
  {
    path: "/admin/report/scheduled-payments",
    component: ScheduledPayments,
  },
  {
    path: "/admin/report/detailed-sales-by-department",
    component: DetailedSalesByDepartment,
  },
  {
    path: "/admin/report/sales-by-accounting-reference",
    component: SalesByAccountingReference,
  },
  {
    path: "/admin/report/inventory-listing-by-department",
    component: InventoryListingByDepartment,
  },
  {
    path: "/admin/report/order-exceptions",
    component: OrderExceptions,
  },
  {
    path: "/admin/report/tee-sheet-utilization",
    component: TeeSheetUtilization,
  },
  {
    path: "/admin/report/email-activity",
    component: EmailActivity,
  },
  {
    path: "/admin/report/golfnorth-daily-sales",
    component: GolfNorthDailySales,
  },
  {
    path: "/admin/report/ticket-overview",
    component: TicketOverview,
  },
  {
    path: "/admin/report/aged-accounts-receivable",
    component: AgedAccountsReceivable,
  },
  {
    path: "/admin/report/inventory-adjustments",
    component: InventoryAdjustments,
  },
  {
    path: "/admin/report/gift-card-activity",
    component: GiftCardActivity,
  },
  {
    path: "/admin/report/tickets-redeemed",
    component: TicketsRedeemed,
  },
  {
    path: "/admin/report/tickets",
    component: Tickets,
  },
  {
    path: "/admin/report/tickets-expired",
    component: TicketsExpired,
  },
  {
    path: "/admin/report/rounds-by-customer-type",
    component: RoundsByCustomerType,
  },
  {
    path: "/admin/report/membership-sales",
    component: MembershipSales,
  },
  {
    path: "/admin/report/tee-sheet-no-show",
    component: NoShow,
  },
  {
    path: "/admin/report/player-spend",
    component: PlayerSpend,
  },
  {
    path: "/admin/report/sales-by-department",
    component: SalesByDepartment,
  },
  {
    path: "/admin/report/accounts-receivable",
    component: AccountsReceivable,
  },
  {
    path: "/admin/report/deposits",
    component: Deposits,
  },
  {
    path: "/admin/report/item-sales-history",
    component: ItemSalesHistory,
  },
  {
    path: "/admin/report/tournaments",
    component: Tournaments,
  },
  {
    path: "/admin/report/events-not-invoiced",
    component: TournamentsNotInvoiced,
  },
  {
    path: "/admin/report/invoices",
    component: Invoices,
  },
  {
    path: "/admin/report/prize-accounts",
    component: PrizeAccounts,
  },
  {
    path: "/admin/report/daily-sales",
    component: DailySales,
  },
  {
    path: "/admin/report/tee-sheet-overview",
    component: TeeSheetOverview,
  },
  {
    path: "/admin/report/hospitality-events-not-invoiced",
    component: HospitalityEventsNotInvoiced,
  },
  {
    path: "/admin/report/orders",
    component: Orders,
  },
  {
    path: "/admin/report/bookings",
    component: Bookings,
  },
  {
    path: "/admin/report/bookings-by-source",
    component: BookingsBySource,
  },
  {
    path: "/admin/report/server-summaries",
    component: ServerSummaries,
  },
  {
    path: "/admin/report/form-responses",
    component: FormResponses,
  },
  {
    path: "/admin/report/detailed-sales-and-inventory-by-department",
    component: DetailedSalesAndInventoryByDepartment,
  },
  {
    path: "/admin/report/leagues",
    component: Leagues,
  },
  {
    path: "/admin/report/hospitality-events",
    component: HospitalityEvents,
  },
  {
    path: "/admin/report/rounds-by-booking-category",
    component: RoundsByBookingCategory,
  },
  {
    path: "/admin/report/payouts",
    component: Payouts,
  },
  {
    path: "/admin/report/processing-fee-transactions",
    component: ProcessingFeeTransactions,
  },
  {
    path: "/admin/report/processing-fee-monthly-summary",
    component: ProcessingFeeMonthlySummary,
  },
  {
    path: "/admin/report/cash-reconciliation",
    component: CashReconciliation,
  },
  {
    path: "/admin/report/gift-cards",
    component: GiftCards,
  },
  {
    path: "/admin/report/rain-checks",
    component: RainChecks,
  },
  {
    path: "/admin/report/tips-by-order",
    component: TipsByOrder,
  },
  {
    path: "/admin/report/waitlist",
    component: Waitlist,
  },
  {
    path: "/admin/report/power-carts",
    component: PowerCarts,
  },
  {
    path: "/admin/report/cancelled-tee-time-orders",
    component: CancelledTeeTimeOrders,
  },
  {
    path: "/admin/report/staff-account-shifts",
    component: StaffAccountShifts,
  },
  {
    path: "/admin/report/bag-storage",
    component: BagStorage,
  },
  {
    path: "/admin/report/cost-of-sales-by-department",
    component: CostOfSalesByDepartment,
  },
  {
    path: "/admin/report/compare-sales-by-date",
    component: CompareSalesByDate,
  },
  {
    path: "/admin/report/bag-storage-by-day",
    component: BagStorageByDay,
  },
  {
    path: "/admin/report/accounts",
    component: Accounts,
  },
  {
    path: "/admin/report/sales-by-accounting-reference-standalone",
    component: SalesByAccountingReferenceStandalone,
  },
  {
    path: "/admin/report/cash-reconciliation-worksheet",
    component: CashReconciliationWorksheet,
  },
  {
    path: "/admin/report/credit-books",
    component: CreditBooks,
  },
  {
    path: "/admin/report/credit-book-transactions",
    component: CreditBookTransactions,
  },
  {
    path: "/admin/report/discounts",
    component: Discounts,
  },
  {
    path: "/admin/report/products",
    component: Products,
  },
  {
    path: "/admin/report/tax-exempt",
    component: TaxExempt,
  },
  {
    path: "/admin/report/user-payment-methods",
    component: UserPaymentMethods,
  },
  {
    path: "/admin/report/booking-deposits",
    component: BookingDeposits,
  },
  {
    path: "/admin/report/account-activity",
    component: AccountActivity,
  },
  {
    path: "/admin/report/hourly-sales",
    component: HourlySales,
  },
  {
    path: "/admin/report/revpar",
    component: RevPAR,
  },
  {
    path: "/admin/report/league-rounds",
    component: LeagueRounds,
  },
  {
    path: "/admin/report/tee-time-promotions",
    component: TeeTimePromotions,
  },
  {
    path: "/admin/report/rounds-played-by-customer",
    component: RoundsPlayedByCustomer,
  },
  {
    path: "/admin/report/outstanding-purchase-order-items",
    component: PurchaseOrderOutstandingItems,
  },
  {
    path: "/admin/report/loyalty-program-points-balance",
    component: LoyaltyProgramPointsBalance,
  },
  {
    path: "/admin/report/customers-created",
    component: CustomersCreated,
  },
  {
    path: "/admin/report/loyalty-program-redemptions",
    component: LoyaltyProgramRedemptions,
  },
].map(route => ({
  ...route,
  component: withReportPresentation(withReportAutoRunRoute(route.component, route.path, "facility")),
}));

export default reportRoutes;
